import { adapter, DEVICES_FEATURE_KEY, DevicesPartialState, DevicesState } from './devices.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getDevicesState = createFeatureSelector<
  DevicesPartialState,
  DevicesState
>(DEVICES_FEATURE_KEY);

const { selectAll, selectEntities } = adapter.getSelectors();

const getError = createSelector( getDevicesState, (state:DevicesState) => state.error );

const getAllDevices = createSelector(
  getDevicesState,
  selectAll
);

const getAllDevicesById = createSelector(
  getDevicesState,
  selectEntities
);

const getLastCreatedId = createSelector( getDevicesState, (state:DevicesState) => state.lastCreatedId );

const getIsSearching = createSelector( getDevicesState, (state:DevicesState) => state.isSearching );

const getSearchResultIds = createSelector( getDevicesState, (state:DevicesState) => state.searchResultIds );

const getPagination = createSelector(getDevicesState, (state: DevicesState) => state.pagination);

const getQuery = createSelector(getDevicesState, (state: DevicesState) => state.query);

const getSorts = createSelector(getDevicesState, (state: DevicesState) =>  state.sorts);

const getFacets = createSelector(getDevicesState, (state: DevicesState) =>  state.facets);

const getActualSort = createSelector(getDevicesState, (state: DevicesState) => state.actualSort);

const getTotalResults = createSelector(getDevicesState, (state: DevicesState) => state.totalResult);


const getSearchResults = createSelector( getAllDevicesById, getSearchResultIds, (entities, searchResultIds) => {
  return searchResultIds.map(id => entities[id]);
});

export const DevicesQuery = {
  getError,
  getAllDevices,
  getAllDevicesById,
  getLastCreatedId,
  getIsSearching,
  getSearchResults,
  getPagination,
  getQuery,
  getSorts,
  getActualSort,
  getTotalResults,
  getFacets
};
